import { FoodStatus, isLogMealById } from '@cf-shared/data-model/food';

/**
 * Whether to offer the Report action on this food.
 *
 * Anything that is not the user's own can be reported. It used to be Contributed foods only, but
 * every food/$-prefixed source -- Open Food Facts included -- resolves to FoodStatus.Official, so
 * a wrong entry from a crowdsourced database could not be reported by anyone (#4541).
 *
 * The three exclusions are all forms of "this is yours, edit it instead of reporting it": a
 * logged meal is the user's own day of eating, Private covers their own foods, and
 * local.hashSource is the author stamp written onto content this user created.
 *
 * One rule for every screen that offers Report. It was written twice until #5520, and the food
 * details screen's copy still said "Contributed only" long after #4541 widened the list's.
 */
export function canReportFood(food: { _id: string; status?: FoodStatus; local?: { hashSource?: string } }): boolean {
  if (isLogMealById(food._id) || food.status === FoodStatus.Private) {
    return false;
  }
  return !food.local?.hashSource;
}
